import * as React from "react";
import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";

import { cn } from "@/lib/utils";
import { CheckIcon } from "lucide-react";
import { useId } from "react";

function SimpleCheckbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "border-input dark:bg-input/30 data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary data-checked:border-primary aria-invalid:aria-checked:border-primary aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 flex size-4 items-center justify-center rounded-[4px] border transition-colors cursor-pointer group-has-disabled/field:opacity-50 group-has-disabled/field:cursor-default focus-visible:ring-3 aria-invalid:ring-3 peer relative shrink-0 outline-none after:absolute after:-inset-x-3 after:-inset-y-2",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="[&>svg]:size-3.5 grid place-content-center text-current transition-none"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
SimpleCheckbox.displayName = "SimpleCheckbox";

function Checkbox({
  className,
  label,
  disabled,
  ...props
}: CheckboxPrimitive.Root.Props & { label?: React.ReactNode }) {
  const reactId = useId();
  if (label) {
    const id = props.id ?? reactId;
    return (
      <div className="group flex flex-row items-center gap-2" data-disabled={disabled ? true : undefined}>
        <SimpleCheckbox className={className} {...props} disabled={disabled} id={id} />
        <label
          htmlFor={id}
          className="text-foreground cursor-pointer group-data-[disabled]:cursor-default group-data-[disabled]:opacity-50 text-sm"
        >
          {label}
        </label>
      </div>
    );
  } else {
    return <SimpleCheckbox className={className} {...props} />;
  }
}

Checkbox.displayName = "Checkbox";

export { Checkbox };
